export const AUDIO_JUMP_SLACK = 2;
